import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import { uuidSchema } from '@/shared/api/schemas'

const branchOptionSchema = z.object({ id: uuidSchema, code: z.string(), name: z.string() })

export type BranchOption = z.infer<typeof branchOptionSchema>

/** Foydalanuvchi abonentga qo'ya oladigan filiallar (ADR-046): tashkilot doirasiga hammasi */
export async function fetchBranchOptions(signal?: AbortSignal): Promise<BranchOption[]> {
  const response = await api.get<unknown>('/api/subscribers/branch-options', { ...(signal ? { signal } : {}) })
  return z.array(branchOptionSchema).parse(response.data)
}

export function useBranchChoices(enabled = true) {
  return useQuery({
    queryKey: queryKeys.branchOptions,
    queryFn: ({ signal }) => fetchBranchOptions(signal),
    enabled,
    staleTime: 5 * 60_000,
  })
}

export function branchLabel(branch: BranchOption): string {
  return `${branch.name} (${branch.code})`
}

export async function setSubscriberBranch(subscriberId: string, branchNodeId: string | null): Promise<void> {
  await api.put(`/api/subscribers/${subscriberId}/branch`, { branchNodeId })
}

export async function setSubscribersBranch(subscriberIds: readonly string[], branchNodeId: string): Promise<number> {
  const response = await api.post<unknown>('/api/subscribers/branch', { subscriberIds, branchNodeId })
  return z.number().parse(response.data)
}
